import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const AccessPage = () => {
  useEffect(() => {
    document.title = 'アクセス｜さかなの木';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] md:h-[70vh] mt-20">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/11fb3646b27facc99a970b3ecd87a6f3.webp"
            alt="さかなの木 アクセス"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-b from-black/25 via-black/20 to-black/25"></div>
          <div className="hero-copy absolute inset-0 flex items-center justify-center text-center text-white px-4">
            <div>
              <h2 className="text-4xl md:text-6xl font-bold text-white">ACCESS</h2>
              <p className="text-lg md:text-xl mt-4 text-white">アクセス</p>
            </div>
          </div>
        </div>
      </section>
      <h1 className="text-center py-1 text-gray-500" style={{ fontSize: '10px', lineHeight: '1.2' }}>アクセス｜鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>

      {/* Map Section */}
      <section className="py-20 relative">
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/fd053d2bfee0e37b04170d70658cec74.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <span className="text-primary text-sm font-bold tracking-wider">LOCATION</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-2" style={{ color: '#3A3D3F' }}>
                鵜の木駅より徒歩30秒
              </h2>
              <p className="text-gray-600 mt-4">
                東急多摩川線 鵜の木駅改札を出て右手すぐ。駅から非常に近く、お仕事帰りやお買い物の後にも気軽にお立ち寄りいただけます。
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-2xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.8447890234567!2d139.6786174!3d35.5754191!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185f8c78e8258d%3A0xc7aca39b96b08092!2z44GV44GL44Gq44Gu5pyo!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="さかなの木 地図"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Store Information Section */}
      <section className="py-20 relative">
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/44777499a53b394db33d497ef750e605.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12">
              {/* Left Column */}
              <div>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#3A3D3F' }}>店舗概要</h2>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                      <i className="ri-store-line text-2xl text-primary"></i>
                    </div>
                    <div>
                      <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>店名</p>
                      <p style={{ color: '#3A3D3F' }}>さかなの木</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                      <i className="ri-map-pin-line text-2xl text-primary"></i>
                    </div>
                    <div>
                      <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>住所</p>
                      <p style={{ color: '#3A3D3F' }}>
                        〒146-0091<br />
                        東京都大田区鵜の木2-5-5<br />
                        イーグル鵜の木原田ビル1階G号
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                      <i className="ri-phone-line text-2xl text-primary"></i>
                    </div>
                    <div>
                      <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>電話番号</p>
                      <p style={{ color: '#3A3D3F' }}>
                        <a href="tel:03-6715-0369" className="hover:text-primary transition-colors cursor-pointer">
                          03-6715-0369
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                      <i className="ri-time-line text-2xl text-primary"></i>
                    </div>
                    <div>
                      <p className="font-bold mb-2" style={{ color: '#3A3D3F' }}>営業時間</p>
                      <div className="space-y-1" style={{ color: '#3A3D3F' }}>
                        <p><strong>ランチ</strong></p>
                        <p className="text-sm">月曜日〜土曜日 11:30-14:00 (LO.13:30)</p>
                        <p className="mt-2"><strong>ディナー</strong></p>
                        <p className="text-sm">月曜日〜木曜日 17:00-22:00</p>
                        <p className="text-sm">(LO.料理21:00 ドリンク21:30)</p>
                        <p className="text-sm">金曜日・土曜日 17:00-23:00</p>
                        <p className="text-sm">(LO.料理22:00 ドリンク22:30)</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                      <i className="ri-calendar-close-line text-2xl text-primary"></i>
                    </div>
                    <div>
                      <p className="font-bold mb-1" style={{ color: '#3A3D3F' }}>定休日</p>
                      <p className="text-red-600 font-medium">日曜日・不定休</p>
                      <p className="text-sm text-gray-600 mt-1">※不定休の詳細はInstagramでご確認ください</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div>
                <h2 className="text-3xl font-bold mb-8" style={{ color: '#3A3D3F' }}>アクセス方法</h2>
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary rounded-full flex-shrink-0">
                      <i className="ri-train-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <p className="font-bold mb-2" style={{ color: '#3A3D3F' }}>電車でお越しの方</p>
                      <p className="mb-2" style={{ color: '#3A3D3F' }}>
                        <strong className="text-primary">東急多摩川線 鵜の木駅</strong>より<br />
                        <span className="text-2xl font-bold text-primary">徒歩30秒</span>
                      </p>
                      <p className="text-sm text-gray-600">
                        改札を出て右手すぐ。駅から非常に近く、雨の日でも安心してお越しいただけます。
                      </p>
                    </div>
                  </div>
                  <div className="pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-600 mb-2"><strong>目印</strong></p>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-primary mt-0.5"></i>
                        <span>鵜の木駅改札を出て右手方向</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-primary mt-0.5"></i>
                        <span>イーグル鵜の木原田ビル1階</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-primary mt-0.5"></i>
                        <span>木目調の温かい雰囲気の外観</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                      <i className="ri-bank-card-line text-2xl text-primary"></i>
                    </div>
                    <div className="w-full">
                      <p className="font-bold mb-3" style={{ color: '#3A3D3F' }}>お支払い方法</p>
                      <div className="space-y-3 text-sm" style={{ color: '#3A3D3F' }}>
                        <div>
                          <p className="font-medium mb-1">クレジットカード</p>
                          <p className="text-gray-600">VISA / Master / JCB / AMEX / Diners</p>
                        </div>
                        <div>
                          <p className="font-medium mb-1">電子マネー</p>
                        </div>
                        <div>
                          <p className="font-medium mb-1">QRコード決済</p>
                          <p className="text-gray-600">PayPay / d払い / 楽天ペイ / au PAY など</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full flex-shrink-0">
                      <i className="ri-wifi-line text-2xl text-primary"></i>
                    </div>
                    <div>
                      <p className="font-bold mb-2" style={{ color: '#3A3D3F' }}>店内設備</p>
                      <ul className="text-sm space-y-1" style={{ color: '#3A3D3F' }}>
                        <li className="flex items-center gap-2">
                          <i className="ri-check-line text-primary"></i>
                          <span>無料Wi-Fi完備</span>
                        </li>
                        <li className="flex items-center gap-2">
                          <i className="ri-check-line text-primary"></i>
                          <span>カウンター席・テーブル席</span>
                        </li>
                        <li className="flex items-center gap-2">
                          <i className="ri-check-line text-primary"></i>
                          <span>各種キャッシュレス決済対応</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative">
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/fe21058cb16651a67f0a29b7d94751f8.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: '#3A3D3F' }}>
            ご来店をお待ちしております
          </h2>
          <p className="text-lg mb-8" style={{ color: '#3A3D3F' }}>
            新鮮な魚介と温かいおもてなしで、皆様をお迎えいたします
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:03-6715-0369"
              className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#B9A176] to-[#D4C4A0] text-white rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
              style={{ boxShadow: '0 8px 20px rgba(185, 161, 118, 0.4)' }}
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>電話予約</span>
            </a>
            <a
              href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#06C755] to-[#05B04D] text-white rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
              style={{ boxShadow: '0 8px 20px rgba(6, 199, 85, 0.4)' }}
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINE予約</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AccessPage;
